import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import ContactModal from "../ContactModal";

function Main1() {
    return (
            <section className="about-section-two style-two layout-pt-60 layout-pb-60 js-tab-menu-content">
                <div className="auto-container">
                    <div className="row grid-base align-items-center">
                        <div className="image-column -no-margin col-xl-5 col-lg-6 col-md-12 col-sm-12 wow fadeInRight">
                            <figure className="image-box image-responsive">
                                <img src="/images/resource/ordinateur.png" alt="opératrice"
                                     style={{position: 'absolute', maxWidth: '240%', bottom: '-400px', right: '-300px'}}/>
                            </figure>
                        </div>

                        <div className="content-column col-xl-5 offset-xl-2 col-lg-5 offset-lg-1 col-md-12 col-sm-12">
                            <div className="wow fadeInLeft">
                                <div className="sec-title">
                                    <h2 className="fw-700">Quand <span>participer ?</span></h2>
                                </div>
                                <div className="text">
                                    Prenez rendez-vous dès maintenant pour <span>un échange de 15 minutes</span> avec un expert Talents Handicap selon les disponibilités :
                                    <ul className="list-style-three">
                                        <li>Mardi 19 novembre 2024 entre 10h00 et 13h00</li>
                                        <li>Jeudi 21 novembre 2024 entre 14h30 et 17h30</li>
                                    </ul>
                                </div>

                                {/*<motion.button
                                        className="theme-btn btn-style-one small"
                                        initial={{opacity: 0, y: 0}}
                                        animate={{opacity: 1, y: 20}}
                                        transition={{delay: 1.0, duration: 1.5}}
                                        data-cal-namespace="ligne-inclusion"
                                        data-cal-link="team/talents-handicap/ligne-inclusion"
                                        data-cal-config='{"layout":"month_view"}'
                                >Réserver un créneau
                                </motion.button>*/}

                                <ContactModal textButton="Réserver un créneau" showText={false} small="small" linkPageContact={false} iframe={true} couleur={false}/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    );
}

export default Main1;
